<template>
  <div class="main">
    <v-row>
      <v-col cols="12" sm="6" md="4">
        <BasicDialog @close="closeDialog">
          <v-row>
            <!-- Iframe containing the Google Form -->
            <v-col cols="12" class="d-flex flex-row justify-center align-center">
              <iframe
                  :src="googleFormUrl"
                  width="100%"
                  height="500"
                  frameborder="0"
                  allowfullscreen
              ></iframe>
            </v-col>
            <v-col cols="12" class="d-flex flex-row justify-center">
              <v-btn rounded="pill" :disabled="!isAvailable || isClaimed"
                     class="upper-border-primary primary-button text-h6 font-weight-medium pl-6 pr-6 py-6 d-flex"
                     @click="customerFeedback">
                <template v-slot:prepend>
                  <v-icon>
                    <coin-big></coin-big>
                  </v-icon>
                </template>
                {{ buttonText }}
              </v-btn>
            </v-col>
          </v-row>
        </BasicDialog>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import BasicDialog from "@/components/Common/Basic-Dialog.vue";
import {UserActivityStore} from "@/store/UserActivityStore";
import {computed, inject, provide, ref} from "vue";
import {AppConfigs} from "@/app.configs";
import CoinBig from "@/icons/CoinBig.vue";

export default {
  name: "CustomerFeedbackDialog",
  components: {
    CoinBig,
    BasicDialog,
  },
  props: {
    dialogOpen: Boolean,
  },
  setup(props, {emit}) {
    let openDialog = inject('inHouseTaskOpenDialog');
    provide('openDialog', openDialog);
    const inHouseTaskStore = UserActivityStore();

    // Define googleFormUrl as a reactive variable
    const googleFormUrl = ref("https://docs.google.com/forms/d/e/1FAIpQLScojLm9dPCm-bCfhJWOb4n89zzaRMqVX_Sq7VFx-zJddqyCSA/viewform?embedded=true");

    const coinsForCustomerFeedback = computed(() => inHouseTaskStore.selectedInHouseTask.coins_amount);
    const isAvailable = computed(() => inHouseTaskStore.selectedInHouseTask.availability_info.is_available);
    const isClaimed = computed(() => inHouseTaskStore.selectedInHouseTask.availability_info.is_available);

    const buttonText = computed(() => isClaimed.value ? "Claimed" : `+ ${coinsForCustomerFeedback.value} Claim`);

    function closeDialog() {
      emit('close');
    }

    function customerFeedback() {
      if (!isClaimed.value) {
        inHouseTaskStore.redeemCoinsForSelectedInHouseTask();
      }
    }

    return {
      AppConfigs,
      closeDialog,
      isAvailable,
      isClaimed,
      customerFeedback,
      coinsForCustomerFeedback,
      googleFormUrl,
      buttonText,
    };
  },
};
</script>
